export const AUTH_TOKEN_KEY = 'wertyuiojhdfghhdrtfyguh';

const SESSION_KEYS = [
  AUTH_TOKEN_KEY,
  'firstname',
  'lastname',
  'email',
  'phone',
  'userid',
  'user_role',
  'current_plan',
  'plan_active_status',
  'referral_code',
  'password',
  'otp',
];

export function getStoredToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function parseJwt(token) {
  if (!token || typeof token !== 'string') {
    return null;
  }

  try {
    const base64Url = token.split('.')[1];

    if (!base64Url) {
      return null;
    }

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.log('Unable to parse auth token:', error);
    return null;
  }
}

export function isTokenExpired(token) {
  const jwtPayload = parseJwt(token);

  if (!jwtPayload || !jwtPayload.exp) {
    return false;
  }

  return jwtPayload.exp < Date.now() / 1000;
}

export function clearStoredSession() {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
}

